import { SVGProps } from 'react';

const Bank = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 18"
    {...props}
  >
    <rect width={24} height={18} fill="#E0E0E0" rx={4} />
    <path
      fill="currentColor"
      d="M7 8v4.667h2V8zm4 0v4.667h2V8zm-5.333 8h12.666v-2H5.667zM15 8v4.667h2V8zm-3-6L5.667 5.333v1.334h12.666V5.333z"
    />
  </svg>
);
export default Bank;
